export default "__VITE_ASSET__BGQPXVsu__"